<template>
	<span
		class="text-xs text-dj-black leading-none my-1 mr-2 pr-2"
		:class="{
			'border-r-[1px] border-dj-black last-of-type:border-0': bordered,
		}"
	>
		<slot></slot>
	</span>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
	name: "DjCardTag",
	props: {
		bordered: {
			type: Boolean,
			default: false,
		},
	},
});
</script>
